<footer
    class="flex flex-col md:flex-row justify-center items-center md:justify-between md:items-end gap-4 relative text-xs {{additionalClasses}}">
    @if (!hideCustomFooter) {
        <p class="flex flex-row items-center md:items-start justify-center md:max-w-[50%] md:justify-start text-center md:text-left">
            <span class="px-base xl:px-base-desk flex flex-col items-center md:items-start justify-center md:justify-between gap-2">
                <span>H2IOSC Project - Humanities and cultural Heritage Italian Open Science Cloud <br /> funded by the
                    European Union - NextGenerationEU - NRRP M4C2 - Project code IR0000029 - CUP B63C22000730005</span>
                <span class="flex flex-row items-center gap-2 logos-container">
                    <span class="hide-in-login flex flex-row gap-2 items-center justify-center">
                        <img class="h-6" src="assets/images/Logo_training_environment.png"
                            title="H2IOSC Training Environment" alt="H2IOSC Training Environment Logo" />
                    </span>
                    <span class="flex flex-row gap-2 items-center justify-center">
                        <img class="h-4" src="assets/images/GarrCloudLogo.png" title="Cloud Hosting Garr"
                            alt="Garr Cloud Logo" /><span class="text-xs">Cloud Hosting Garr</span>
                    </span>
                </span>
            </span>
        </p>
    }
    @if (!hideMetaCredits) {
        <p class="flex flex-col gap-2 items-center md:items-end md:text-right">
            {{'Layout Design & Web Development' | translate}}<br />
            <span class="flex gap-3 items-center">
                <a href="https://www.gruppometa.it/" title="Vai al sito web di GruppoMeta">
                    <img src="core/assets/images/logoMeta.svg" class="max-h-[1.5rem]" alt="Logo GruppoMeta"/>
                </a>
                @if (showEttLogo) {
                    <a href="https://ettsolutions.com/" title="Vai al sito web di ETT Solutions">
                        <img src="core/assets/images/ett.png" class="max-h-[1.5rem]" alt="Logo ETT Solutions"/>
                    </a>
                }
            </span>
        </p>
    }
</footer>